
/// formatter query 
export const formatterQuery = (objectQuery) => {

  var queries = "";

  for (var i = 0; i < objectQuery.length; i++) {
    queries += `${objectQuery[i]['aliasName']}: ${objectQuery[i]['entityName']}(${objectQuery[i]['params']}) ${objectQuery[i]['reponse']}`;
  }
  
  return queries;
}

/// formatter mutation
export const formatterMutation = (objectMutation) => {

  var mutations = "";

  for (var i = 0; i < objectMutation.length; i++) {
    mutations += `${objectMutation[i]['aliasName']}: ${objectMutation[i]['entityName']}(${objectMutation[i]['params']}) ${objectMutation[i]['reponse']}`;
  }
  
  return mutations;
}

/// Convert File to bae64
export const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob); 
    reader.onloadend = () => {
      const base64data = reader.result;   
      resolve(base64data);
    }
  });
}

export const converFileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});


/// Clear cache to app 
export const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
};

/// Return Enum from type File
export const imageUploadAux = (document) => {
  switch(document) {
    case 'IFEfront':
        return 'ifeFront';
    case 'IFEreverse':
        return 'ifeBack';
    case 'selfie':
        return 'selfie';
    case 'proofadress':
        return 'proofAdress';
    default:
        return 'ifeFront';
  }
}

///// Validations
export const emailValidation = (email) => {
  return /.+@.+\..+/.test(email);
}

export const curpValida = (curp) => {
  if(curp.match(/^([a-z]{4})([0-9]{6})([a-z]{6})([0-9]{2})$/i)){//AAAA######AAAAAA##
    return true
  }else{
    return false
  }
}

export const phoneValidation = (phone) => {
  
  let numberPhone = phone.toString();
  let numberClean = numberPhone.replace(/ /g, "");

  if ( /^[\+]52([0-9]+){13}$/g.test(numberClean) || /^([0-9]+){9}$/g.test(numberClean)) {
    return true;
  } else {
    return false;
  }

}

export const phoneValidationOnly = (phone) => {
  
  let numberPhone = phone.toString();
  let numberClean = numberPhone.replace(/ /g, "");

  console.log(numberPhone)

  if (/^(?:\D*\d){10}\D*$/.test(numberClean)) {
    return true;
  } else {
    return false;
  }

}

export const phoneValidationLng = (phone) => {
  
  let numbePhone =  phone.toString();

  if (numbePhone.length < 10) {
    return false;
  } else {
    return true;
  }

}

export const validateNumber = (amount) => {

  if( /^([0-9]+)$/g.test(amount)){
    return true;
  }else if(/^\d*\.?\d*$/g.test(amount)){
    return true;
  }else{
    return false;
  }

}

export const validateCard = (card) => {

  const longCard = card.length;
  if (longCard < 15) {
    return false;
  } else if (longCard === 15) {
    const valueCard = /^([0-9]+){15}$/g.test(card);
    return valueCard;
  } else if (longCard === 16) {
    const valueCard = /^([0-9]+){16}$/g.test(card);
    return valueCard;
  }

}


export const validateCVC = (cvc) => {
  return /^([0-9]+){3}$/g.test(cvc);
}

export const validateMonth = (month) => {
  if (month > 12) {
    return false;
  }
  else {
    return /^([0-9]+){2}$/g.test(month);
  }
}

export const validateYear = (year) => {

  return /^([0-9]+){2}$/g.test(year);
}

export const flattenMessages = (nestedMessages, prefix = "") => {
    if (!nestedMessages || nestedMessages === null) {
      return {};
    }
    return Object.keys(nestedMessages).reduce((messages, key) => {
          const value = nestedMessages[key];
          const prefixedKey = prefix ? `${prefix}.${key}` : key;
      
          if (typeof value === "string") {
            Object.assign(messages, { [prefixedKey]: value });
          } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
          }
      
          return messages;
    }, {});
  };